import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import {
  FieldTooltip,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { PlusIcon } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import WorkflowsLanding from "../tabs/workflows/landing/landing";
import RunHistoryLanding from "../tabs/runHistory/landing/landing";

const WorkflowLanding = () => {
  const CreateWorkflowButton = () => {
    const navigate = useNavigate();

    const handleCreateTemplate = () => {
      navigate("/communication-hub/workflows/create");
    };

    return (
      <Button onClick={handleCreateTemplate}>
        <PlusIcon className="h-4 w-4 mr-2" />
        Add Workflow
      </Button>
    );
  };
  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <PageHeader
            title="Workflows"
            subtitle="Automate your communication campaigns"
          />
        </div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <CreateWorkflowButton />
            </TooltipTrigger>
            <FieldTooltip>Create a new workflow</FieldTooltip>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="workflows"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
            urlMapping={{
              workflows: "workflows",
              runHistory: "runHistory",
            }}
            tabComponents={{
              workflows: {
                label: "Workflows",
                component: <WorkflowsLanding />,
              },
              runHistory: {
                label: "Run History",
                component: <RunHistoryLanding />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkflowLanding;
